import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles,
} from "@material-ui/core";
import NavBarItem from "../../../components/layout/NavBarItem";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import DescriptionIcon from "@material-ui/icons/Description";
import KmVersion from "../../../components/layout/KmVersion";
import TodayIcon from "@material-ui/icons/Today";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import InputIcon from "@material-ui/icons/Input";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import PolicyIcon from "@material-ui/icons/Policy";
import InfoIcon from "@material-ui/icons/Info";
import HowToVoteIcon from "@material-ui/icons/HowToVote";

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: theme.dimensionscustom.menuWidth,
  },
  desktopDrawer: {
    width: theme.dimensionscustom.menuWidth,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

const NavBar = ({
  onMobileClose,
  openMobile,
  isAuthorized,
  setLogoutUser,
  calendarEventsCount,
  version,
}) => {
  const classes = useStyles();
  const location = useLocation();

  console.log("ENV: " + process.env.REACT_APP_PUBLIC_VOIDING);

  const items = [
    {
      href: "/aktualnosci",
      icon: AnnouncementIcon,
      title: "Aktualności",
    },
    {
      href: "/dokumenty",
      icon: DescriptionIcon,
      title: "Dokumenty",
    },
    {
      href: "/kalendarz",
      icon: TodayIcon,
      title: "Kalendarz",
      badge: calendarEventsCount,
      reloadPath: "kalendarz",
    },
    process.env.REACT_APP_PUBLIC_VOIDING === "true"
      ? {
          href: "/glosowania",
          icon: HowToVoteIcon,
          title: "Głosowania",
        }
      : null,
    {
      href: "/pomoc/deklaracjadostepnosc",
      icon: AccessibilityIcon,
      title: "Deklaracja dostępności",
    },
    {
      href: "/pomoc/klauzulaobinf",
      icon: InfoIcon,
      title: "Klauzula obowiązku informacyjnego",
    },
    {
      href: "/pomoc/politykaprywatnosci",
      icon: PolicyIcon,
      title: "Polityka prywatności",
    },
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        mt={2}
        mb={1}
      >
        {isAuthorized ? (
          <Button
            color="secondary"
            variant="contained"
            size="small"
            onClick={setLogoutUser}
            endIcon={<PowerSettingsNewIcon>wyloguj</PowerSettingsNewIcon>}
          >
            Wyloguj
          </Button>
        ) : (
          <Button
            color="primary"
            variant="contained"
            size="small"
            component={RouterLink}
            to={"/logowanie"}
            className={classes.button}
            startIcon={<InputIcon />}
          >
            Zaloguj
          </Button>
        )}
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items
            .filter((item) => item != null) // to filter out contition voting
            .map((item) => (
              <NavBarItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                badge={item.badge}
                edit={"edycjatest"}
                reloadPath={item.reloadPath}
              />
            ))}
        </List>
      </Box>
      <Box flexGrow={1}></Box>
      <Box p={2} m={2}>
        <KmVersion version={version} />
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default NavBar;
